module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode-modal"
  }, [_c('mt-popup', {
    staticClass: "guestInfo-delay",
    attrs: {
      "popup-transition": "popup-fade"
    },
    model: {
      value: (_vm.bshow),
      callback: function($$v) {
        _vm.bshow = $$v
      },
      expression: "bshow"
    }
  }, [_c('div', {
    ref: "poster",
    staticClass: "delayIn-main"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('scanPay_title')))]), _vm._v(" "), _c('div', {
    staticClass: "guestSwiper"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('memberDetailPay_payment')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('gpicker', {
    ref: "payCode",
    attrs: {
      "placeholder": _vm.$t('msg_choose_checkMethod')
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('fangTXQ_transactionAmount')))]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.price),
      expression: "price"
    }],
    staticClass: "inp",
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('fangTXQ_pleaseTransactionAmount')
    },
    domProps: {
      "value": (_vm.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.price = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('div', {
    staticClass: "unSure",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sure",
    on: {
      "click": _vm.onExport
    }
  }, [_vm._v(_vm._s(_vm.$t('fangTXQ_generateQrCode')) + "\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-dd53c480","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/page/fangTXQ/fangTXQ-comp/formQrCodeModal.vue
// module id = 1841
// module chunks = 107